import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export interface KevelAdBaseEntityParams {
  object_tracking_id?: string;
  ad_id?: number;
  advertiser_id?: number;
  campaign_id?: number;
  creative_id?: number;
  flight_id?: number;
  placement_name: string;
  priority_id?: number;
  events?: Array<{ type: string; url: string }>;
}

export class KevelAdBaseEntity extends BaseEntityClass {
  object_tracking_id?: string;
  ad_id?: number;
  advertiser_id?: number;
  placement: string;
  flight_id?: number;
  campaign_id?: number;
  creative_id?: number;
  priority_id: number;
  events: Array<{ type: string; url: string }>;
  constructor(params: KevelAdBaseEntityParams) {
    super();
    this.entity_version = 2;
    this.object_tracking_id = params.object_tracking_id;
    this.ad_id = params.ad_id;
    this.advertiser_id = params.advertiser_id;
    this.placement = params.placement_name;
    this.flight_id = params.flight_id;
    this.campaign_id = params.campaign_id;
    this.priority_id = params.priority_id;
    this.creative_id = params.creative_id;
    this.events = params.events;
  }
}
